import styled from "styled-components";

export const Container = styled.div`
  display: none;
  z-index: 2;
  position: absolute;
  height: 30vh;
  width: 30vw;
  max-width: 900px;
  max-height: 500px;
  margin-left: 35%;
  margin-top: 10%;
  padding: 1% 2%;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 45px;
`;
